import classNames from 'classnames';
import { closest, hasClass } from 'dom-helpers';
import React from 'react';

interface PropTypes {
  label?: string;
  name: string;
  className?: string;
  children: React.ReactNode;
  onHover?: (isHover: boolean) => void;
  onClick?: () => void;
  hideArrowIcon?: boolean;
  isOpen: boolean;
}

export default function FilterItem({
  name,
  label,
  children,
  hideArrowIcon,
  isOpen,
  onClick,
  onHover,
  className,
}: PropTypes) {
  return (
    <div
      className={classNames('field', className, isOpen && 'is-active')}
      id={`field-${name}`}
      onClick={e => {
        if (
          (e.target && hasClass(e.target as Element, '.dropdown-menu')) ||
          closest(e.target as Element, '.dropdown-menu')
        ) {
          return;
        }

        if (onClick) {
          onClick();
        }
      }}
      onMouseOver={_ => onHover && onHover(true)}
      onMouseLeave={_ => onHover && onHover(false)}
    >
      <label className="label" htmlFor={name}>
        {label ?? ''}
      </label>
      {children}
      {!hideArrowIcon ? (
        <span className="filter-icon">
          <i className="eb eb-rd" />
        </span>
      ) : null}
    </div>
  );
}

FilterItem.defaultProps = {
  hideArrowIcon: false,
  className: '',
};
